import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCampaignView } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/campaignview.scss";

const Campaign = () => {
  const [loading, setLoading] = useState(false);

  const id = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let token = localStorage.getItem("accessToken");

  const campaignView = useSelector((state) => state.campaignView);
  const { campaign } = campaignView;

  useEffect(() => {
    dispatch(getCampaignView(token, id));
  }, [dispatch]);

  useEffect(() => {}, [campaign]);

  useEffect(() => {
    if (campaignView) {
      if (campaignView?.loading !== undefined) {
        setLoading(campaignView?.loading);
      }
    }
  }, [campaignView]);

  const approveCampaign = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-campaign-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        campaign_id: id.campaignId,
        campaign_status: 3,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          Swal.fire({
            title: response.data.message,
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/active-campaign");
        }
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error.response.data.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const declineCampaign = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-campaign-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        campaign_id: id.campaignId,
        campaign_status: 2,
        reason: "",
      },
    };

    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          Swal.fire({
            title: "Decline Succesffully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
          navigate("/rejected-campaign");
        }
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response.status == 401) {
          Swal.fire({
            title: "Your session has expired...",
            timer: 6500,
            timerProgressBar: true,
            icon: "error",
            text: "Please Login again!",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
      });
  };

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="top">
          <div className="left">
            <h1 className="title">
              You can click on Approve / Decline button below to respond.
            </h1>
            <div className="item">
              {campaign?.data?.map((camp, i) => (
                <div className="details profile-info">
                  <div className="detailItem">
                    <span className="itemKey">Company Name:</span>
                    <span className="itemValue">
                      {camp.corporation_legal_name}
                    </span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Buisness Category:</span>
                    <span className="itemValue">{camp.business}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Website Url:</span>
                    <span className="itemValue">{camp.website}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Companay Location:</span>
                    <span className="itemValue">{camp.city}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Buisness:</span>
                    <span className="itemValue"> {camp.business}</span>
                  </div>
                  <div className="detailItem">
                    <span className="itemKey">Crax Account :</span>
                    <span className="itemValue"> {camp.craax_account}</span>
                  </div>
                  {/* <div className="blink-message">
                    {camp.user.userStatus == 0 ? (
                      <p className="blink-error">This user is inactive.</p>
                    ) : (
                      ""
                    )}
                  </div> */}
                  <div className="submitButton">
                    <Button
                      variant="contained"
                      // disabled={camp.user.userStatus == 0 ? true : false}
                      className="approveButton"
                      // className={
                      //   camp.user.userStatus == 0
                      //     ? "disabled-approveButton"
                      //     : "approveButton"
                      // }
                      onClick={approveCampaign}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="contained"
                      className="declineButton"
                      onClick={declineCampaign}
                    >
                      Decline
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Campaign;
